module.exports = __webpack_public_path__ + "img/empty_illustration_rooms.88c1c980.png";